export const updateObject = (oldObject, updatedProperties) => {
    return {
        ...oldObject,
        ...updatedProperties
    };
};

export const checkValidity = (value, rules) => {
    let isValid = true;

    if(rules.required){
      isValid = value.trim() !== '' && isValid;
    }

    if(rules.minLength){
      isValid = value.length >= rules.minLength && isValid;
    }

    if(rules.maxlength){
        isValid = value.length <= rules.maxlength && isValid;
      }

    if(rules.isEmail){
      const pattern = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
      isValid= pattern.test(value) && isValid;
    }

    return isValid;
  }




// WEBPACK FOOTER //
// ./src/shared/utility.js